/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';

import { index, callback, install, uninstall, webhook } from './controller';
import { sidebar } from '../controller';

export default (router) => {
    router(`/sgc/install`, sidebar, install, makeLayout, render);
    router(`/sgc/uninstall`, sidebar, uninstall, makeLayout, render);
    router(`/sgc/callback`, sidebar, callback, makeLayout, render);
};